import Vue from "vue";
import vueBar from 'vuebar';
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import axios from './axios/axios';
import "./registerServiceWorker";

Vue.config.productionTip = false;
Vue.use(vueBar);
Vue.prototype.$http = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
